// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane__2hnjw","new-pane":"new-pane__1wMId"};